import { ColorScheme } from "./color_scheme.js";
import type { UITextElement } from "./ui_text_element.js";

const OUTLINE_W_DESIGN = 8;
const OUTLINE_OFFSET_Y_DESIGN = 2;

export function setButtonTextOutline(
  texts: readonly ( UITextElement | null | undefined )[],
  active: boolean,
  active_color: string,
  scale = 1
): void
{
  const width = LayoutScaler.textBorderSizeFromDesign( OUTLINE_W_DESIGN * scale );
  const offset_y = LayoutScaler.yFromDesign( OUTLINE_OFFSET_Y_DESIGN * scale );
  const color = active ? active_color : ColorScheme.non_active_btn_outline;
  for ( const text of texts )
  {
    if ( !text ) continue;
    text.setOutline( width, color, 0, offset_y );
    text.invalidateSubtree();
  }
}
